export const categories = [
  {
    id: 'dingyi-yongtu',
    name: '定义与用途',
    slug: 'dingyi-yongtu',
    description: '了解黄本子的基本概念、核心用途及适用场景',
    icon: 'ri-book-read-line',
    articleCount: 8,
  },
  {
    id: 'huoqu-fangshi',
    name: '获取方式',
    slug: 'huoqu-fangshi',
    description: '详尽的办理流程、所需材料及办理地点指南',
    icon: 'ri-file-list-3-line',
    articleCount: 10,
  },
  {
    id: 'zhuyi-shixiang',
    name: '注意事项',
    slug: 'zhuyi-shixiang',
    description: '常见误区、使用禁忌及合规操作提醒',
    icon: 'ri-alert-line',
    articleCount: 6,
  },
  {
    id: 'changjian-wenti',
    name: '常见问题',
    slug: 'changjian-wenti',
    description: '热门问答汇总，快速找到你关心的答案',
    icon: 'ri-question-answer-line',
    articleCount: 15,
  },
  {
    id: 'falv-zhengce',
    name: '法律政策',
    slug: 'falv-zhengce',
    description: '相关法律法规、政策文件与最新动态解读',
    icon: 'ri-scales-3-line',
    articleCount: 5,
  },
  {
    id: 'shiyong-jiqiao',
    name: '使用技巧',
    slug: 'shiyong-jiqiao',
    description: '实用经验分享，让黄本子使用更高效便捷',
    icon: 'ri-lightbulb-line',
    articleCount: 7,
  },
];

export const allArticles = [
  {
    id: 'article-1',
    title: '黄本子的基本定义与历史沿革',
    excerpt: '黄本子作为一种重要的官方凭证，其定义和历史发展经历了多次演变。本文将全面梳理黄本子的基本概念，帮助读者建立正确的认知框架。',
    categoryId: 'dingyi-yongtu',
    categoryName: '定义与用途',
    readTime: '8分钟',
    publishDate: '2026年7月15日',
    imageSeq: 'article-cover-01',
    isFeatured: true,
    content: `
      <h2>什么是黄本子？</h2>
      <p>黄本子是一种具有法律效力的官方凭证文件，因其封面通常为黄色而得名。它由国家相关主管部门统一印制和发放，是持有人身份、资格或权利的重要证明。</p>
      <p>在实际应用中，黄本子的具体含义可能因行业和场景而有所不同，但其核心功能始终围绕"凭证"和"记录"两大关键词展开。</p>
      
      <h2>黄本子的历史沿革</h2>
      <p>黄本子的历史可以追溯到上世纪初期。最早的黄本子主要用于特定行业的从业资格认证。随着社会的发展和制度的完善，黄本子的应用范围逐渐扩大。</p>
      <p>经过数十年的演进，今天的黄本子已经形成了一套完整的管理体系，包括统一的格式规范、严格的发放流程和系统的信息记录功能。</p>
      
      <h2>黄本子的核心特征</h2>
      <ul>
        <li><strong>官方性：</strong>由国家授权机构统一印制，具有法定效力</li>
        <li><strong>唯一性：</strong>每本黄本子拥有唯一编号，不可复制</li>
        <li><strong>时效性：</strong>通常设有有效期限，需要定期更新</li>
        <li><strong>规范性：</strong>内容和格式符合国家统一标准</li>
      </ul>
    `,
  },
  {
    id: 'article-2',
    title: '黄本子的五大核心用途详解',
    excerpt: '黄本子的用途远比你想象的要广泛。本文详细拆解黄本子在实际生活中的五大核心用途，帮助您充分理解其价值。',
    categoryId: 'dingyi-yongtu',
    categoryName: '定义与用途',
    readTime: '10分钟',
    publishDate: '2026年7月10日',
    imageSeq: 'article-cover-02',
    isFeatured: true,
    content: `
      <h2>用途一：身份资格认证</h2>
      <p>黄本子是持有人在特定领域具备相应资格的直接证明。无论是就业、入学还是参与特定活动，黄本子都能作为有效的资格凭证。</p>
      
      <h2>用途二：信息记录与追踪</h2>
      <p>黄本子中记录了持有人的重要信息，这些信息可用于后续的追踪和管理。信息的完整性和准确性对于黄本子的有效性至关重要。</p>
      
      <h2>用途三：合规审查依据</h2>
      <p>在各类合规审查中，黄本子是最重要的参考依据之一。相关部门可通过查验黄本子快速了解持有人的相关情况。</p>
      
      <h2>用途四：跨境出行必备</h2>
      <p>对于需要跨境出行的人士，黄本子是必不可少的随身证件之一，部分国家和地区明确要求入境时出示有效的黄本子。</p>
      
      <h2>用途五：权益保障凭证</h2>
      <p>黄本子在特定场景下可作为持有人主张合法权益的有效凭证，在纠纷处理中发挥重要作用。</p>
    `,
  },
  {
    id: 'article-3',
    title: '黄本子办理全流程指南（2026最新版）',
    excerpt: '从预约到领取，我们将带您逐步了解2026年黄本子办理的最新流程，让您少走弯路，高效办理。',
    categoryId: 'huoqu-fangshi',
    categoryName: '获取方式',
    readTime: '12分钟',
    publishDate: '2026年7月8日',
    imageSeq: 'article-cover-03',
    isFeatured: true,
    content: `
      <h2>第一步：在线预约</h2>
      <p>登录官方指定平台，选择就近的办理网点，根据系统提示填写个人信息并选择预约时间。预约成功后系统会发送确认短信。</p>
      
      <h2>第二步：准备材料</h2>
      <p>办理黄本子需要准备以下材料：身份证明文件原件及复印件、近期免冠照片、填写完整的申请表格、相关证明文件（如适用）。</p>
      
      <h2>第三步：现场办理</h2>
      <p>按照预约时间抵达办理网点，提交材料并进行信息核验。工作人员会进行材料审核和系统录入。</p>
      
      <h2>第四步：缴费与领取</h2>
      <p>审核通过后缴纳工本费，选择自取或邮寄方式领取。通常办理周期为5-15个工作日。</p>
    `,
  },
  {
    id: 'article-4',
    title: '黄本子办理所需材料清单',
    excerpt: '准备材料是办理黄本子的关键环节。本文提供完整的材料清单及每项材料的具体要求，确保您一次准备到位。',
    categoryId: 'huoqu-fangshi',
    categoryName: '获取方式',
    readTime: '6分钟',
    publishDate: '2026年7月5日',
    imageSeq: 'article-cover-04',
    isFeatured: false,
    content: `
      <h2>必备材料清单</h2>
      <ul>
        <li><strong>身份证原件及复印件：</strong>需在有效期内，复印件需清晰可辨</li>
        <li><strong>户口本原件及复印件：</strong>提供本人页和户主页</li>
        <li><strong>近期免冠白底彩色照片：</strong>需2张，规格为33mm×48mm</li>
        <li><strong>申请表格：</strong>可在官网下载或现场领取</li>
        <li><strong>相关资格证明：</strong>根据申请类型提供相应证明</li>
      </ul>
      <h2>特殊情形补充材料</h2>
      <p>如涉及委托代办、未成年人申请等特殊情形，还需额外提供委托书、监护人证明等材料。</p>
    `,
  },
  {
    id: 'article-5',
    title: '使用黄本子的十大注意事项',
    excerpt: '不正确使用黄本子可能导致严重后果。本文整理了十大关键注意事项，帮助您规避风险，安全合规使用。',
    categoryId: 'zhuyi-shixiang',
    categoryName: '注意事项',
    readTime: '9分钟',
    publishDate: '2026年7月1日',
    imageSeq: 'article-cover-05',
    isFeatured: true,
    content: `
      <h2>1. 妥善保管，防止遗失</h2>
      <p>黄本子一旦遗失，补办流程繁琐且耗时，建议存放在固定位置，避免随身携带非必需场合。</p>
      
      <h2>2. 注意有效期，及时更新</h2>
      <p>黄本子设有有效期限，过期后需及时办理更新手续。建议提前1-2个月关注到期时间。</p>
      
      <h2>3. 不得涂改或伪造</h2>
      <p>任何形式的涂改和伪造都属于违法行为，将承担相应的法律责任。</p>
      
      <h2>4. 信息变更及时申报</h2>
      <p>如个人关键信息发生变更，需在规定时间内办理信息更新手续。</p>
      
      <h2>5. 出境前确认有效性</h2>
      <p>计划出境前务必确认黄本子在目的地国家是否被认可及是否在有效期内。</p>
    `,
  },
  {
    id: 'article-6',
    title: '黄本子常见误区与真相',
    excerpt: '关于黄本子的各种说法鱼龙混杂。本文为您澄清十个最常见的误区，还原真相，避免被误导。',
    categoryId: 'zhuyi-shixiang',
    categoryName: '注意事项',
    readTime: '7分钟',
    publishDate: '2026年6月28日',
    imageSeq: 'article-cover-06',
    isFeatured: false,
    content: `
      <h2>误区一：黄本子可以随意转借他人</h2>
      <p>真相：黄本子属于个人专属凭证，严禁转借他人使用，违者将面临法律处罚。</p>
      
      <h2>误区二：过期后自动作废无需处理</h2>
      <p>真相：过期不等于自动作废，部分场景下逾期未更新可能影响后续办理。</p>
      
      <h2>误区三：网上购买的黄本子同样有效</h2>
      <p>真相：非官方渠道获取的黄本子均为非法无效凭证，使用将承担法律后果。</p>
    `,
  },
  {
    id: 'article-7',
    title: '黄本子丢失后的紧急处理方案',
    excerpt: '万一黄本子丢失了该怎么办？本文提供完整的紧急处理流程图和分步操作指南，帮助您从容应对。',
    categoryId: 'changjian-wenti',
    categoryName: '常见问题',
    readTime: '5分钟',
    publishDate: '2026年6月25日',
    imageSeq: 'article-cover-07',
    isFeatured: false,
    content: `
      <h2>立即挂失</h2>
      <p>发现黄本子丢失后，应第一时间通过官方平台或电话进行挂失，防止被他人冒用。</p>
      
      <h2>报案备案</h2>
      <p>建议到就近派出所报案备案，获取报案回执。这是后续补办的重要凭证之一。</p>
      
      <h2>申请补办</h2>
      <p>携带报案回执、身份证明等材料前往原发证机构申请补办，补办周期通常为10-20个工作日。</p>
    `,
  },
  {
    id: 'article-8',
    title: '黄本子有效期查询与更新指南',
    excerpt: '不确定黄本子何时到期？本文详细介绍有效期查询方法和到期更新流程，再也不错过更新时间。',
    categoryId: 'changjian-wenti',
    categoryName: '常见问题',
    readTime: '4分钟',
    publishDate: '2026年6月20日',
    imageSeq: 'article-cover-08',
    isFeatured: false,
    content: `
      <h2>如何查询有效期</h2>
      <p>黄本子的有效期通常印于封面或首页，同时可以通过官方平台输入编号进行在线查询。</p>
      
      <h2>更新流程</h2>
      <p>到期前1-2个月即可申请更新，流程与新办类似但相对简化，通常只需进行信息核验和缴费。</p>
    `,
  },
  {
    id: 'article-9',
    title: '黄本子相关法律法规解读',
    excerpt: '了解黄本子涉及的法律框架和核心法规条款，做知法守法的合法持有者。',
    categoryId: 'falv-zhengce',
    categoryName: '法律政策',
    readTime: '11分钟',
    publishDate: '2026年6月15日',
    imageSeq: 'article-cover-09',
    isFeatured: false,
    content: `
      <h2>法律依据</h2>
      <p>黄本子的发放和管理依据国家相关法律法规执行，持有人的权利和义务受法律保护。</p>
      
      <h2>违规处罚</h2>
      <p>伪造、变造、买卖黄本子等行为将依据相关法律条款追究行政或刑事责任。</p>
    `,
  },
  {
    id: 'article-10',
    title: '2026年黄本子政策最新变化解读',
    excerpt: '2026年黄本子相关政策迎来多项调整。本文为您深度解读变化要点，助您第一时间掌握最新动态。',
    categoryId: 'falv-zhengce',
    categoryName: '法律政策',
    readTime: '8分钟',
    publishDate: '2026年6月10日',
    imageSeq: 'article-cover-10',
    isFeatured: true,
    content: `
      <h2>数字化升级</h2>
      <p>2026年起，黄本子逐步推行电子化版本，与纸质版本具有同等法律效力，办理更加便捷。</p>
      
      <h2>办理流程优化</h2>
      <p>多项流程实现线上化，减少线下跑腿次数，办理周期有望进一步缩短。</p>
    `,
  },
  {
    id: 'article-11',
    title: '在线办理黄本子的快捷通道',
    excerpt: '足不出户即可完成黄本子申请。本文带你了解在线办理全流程，适合忙碌的上班族和异地办理人群。',
    categoryId: 'huoqu-fangshi',
    categoryName: '获取方式',
    readTime: '7分钟',
    publishDate: '2026年6月5日',
    imageSeq: 'article-cover-11',
    isFeatured: false,
    content: `
      <h2>支持在线办理的业务类型</h2>
      <p>目前支持在线办理的业务包括：首次申请（部分城市）、到期更新、信息变更、挂失补办等。</p>
      
      <h2>在线办理步骤</h2>
      <p>登录官方平台 → 选择业务类型 → 填写信息 → 上传材料 → 在线缴费 → 等待审核 → 邮寄领取</p>
    `,
  },
  {
    id: 'article-12',
    title: '黄本子保管与维护的最佳实践',
    excerpt: '黄本子作为重要凭证需要妥善保管。本文分享专业级的保管技巧和维护方法，延长黄本子使用寿命。',
    categoryId: 'shiyong-jiqiao',
    categoryName: '使用技巧',
    readTime: '5分钟',
    publishDate: '2026年6月1日',
    imageSeq: 'article-cover-12',
    isFeatured: false,
    content: `
      <h2>存放环境要求</h2>
      <p>黄本子应存放在干燥、避光、常温的环境中，避免潮湿、高温和阳光直射，防止纸张老化和字迹褪色。</p>
      
      <h2>使用保护套</h2>
      <p>建议使用透明保护套包裹黄本子，既能防水防尘，又不影响日常查验。</p>
      
      <h2>复印备份</h2>
      <p>建议将黄本子关键页面复印备份，并存放在不同于原件的位置，以备不时之需。</p>
    `,
  },
];

export const faqs = [
  {
    question: '黄本子是什么？',
    answer: '黄本子是一种由国家授权机构统一印制和发放的官方凭证文件，具有法律效力。它通常用于记录和证明持有人的特定资格、身份或权利，是重要的个人证件之一。',
  },
  {
    question: '黄本子有哪些主要用途？',
    answer: '黄本子的主要用途包括：身份资格认证、信息记录与追踪、合规审查依据、跨境出行必备证件以及权益保障凭证。具体用途因黄本子类型和个人情况而异。',
  },
  {
    question: '如何获取黄本子？',
    answer: '获取黄本子需通过官方指定渠道办理。一般流程为：在线预约 → 准备材料 → 现场办理 → 缴费领取。部分业务已支持全程在线办理。具体所需材料和流程请参考本网站的"获取方式"分类。',
  },
  {
    question: '黄本子有有效期吗？',
    answer: '是的，黄本子通常设有有效期限。有效期长短根据类型不同而有所差异。到期前需及时办理更新手续，以免影响正常使用。具体有效期可查看黄本子封面或首页标注。',
  },
  {
    question: '黄本子丢失了怎么办？',
    answer: '如黄本子丢失，请按以下步骤处理：1）立即通过官方渠道挂失；2）到派出所报案备案获取回执；3）携带报案回执和身份证明到原发证机构申请补办。补办周期通常为10-20个工作日。',
  },
  {
    question: '黄本子可以在线办理吗？',
    answer: '可以。目前多个城市的黄本子业务已支持在线办理，包括到期更新、信息变更、挂失补办等。首次申请在部分地区也支持线上办理。请关注官网最新开通的城市列表。',
  },
  {
    question: '黄本子可以转借给他人使用吗？',
    answer: '不可以。黄本子属于个人专属凭证，严禁转借、出租或出售给他人使用。违规使用将承担相应法律责任，并可能影响自身的信用记录。',
  },
  {
    question: '黄本子与电子版有什么区别？',
    answer: '2026年起推行的电子版黄本子与纸质版具有同等法律效力。电子版的优势在于随身携带方便、支持在线查验，且不存在丢失风险。但部分场景仍可能需要出示纸质原件，建议两者都备好。',
  },
];

export const siteInfo = {
  name: '黄本子官方指南',
  tagline: '最权威、最详尽的黄本子专题落地页',
  description: '黄本子官方指南致力于为用户提供全面、准确、及时的黄本子相关信息，帮助每一位用户快速了解黄本子的核心价值，掌握正确使用方法。',
  founded: '2024年',
  email: 'contact@huangbenzi.com',
  phone: '400-888-XXXX',
  address: '北京市朝阳区XX大厦',
};